import styled, { css } from "styled-components";
import { ColorThemesEnum as Buttons } from "@streeteasy/design-system/deprecated/Button/styled";
import colors from "@streeteasy/design-system/deprecated/colors";
import { Form as FormikForm } from "formik";

import { largeScreen } from "src/shared/constants/screenSizes";

export const StepWrapper = styled.div`
  background: ${colors.pureWhite};
  padding: 24px;

  ${({ $hasDrawerForm }) =>
    $hasDrawerForm &&
    css`
      height: 100%;

      @media (min-width: ${largeScreen}px) {
        padding: 0;
      }
    `}
`;

export const Form = styled(FormikForm)`
  background: ${colors.pureWhite};
  margin: 0;

  ${({ $hasDrawerForm }) =>
    $hasDrawerForm
      ? css`
          display: flex;
          flex-direction: column;
          height: 100%;
          text-align: left;
        `
      : css`
          width: 100%;
        `}
`;

export const SubmitButton = Buttons.primary;
